import { Connector } from "../../../../components/types";

// Real Airbyte sourceDefinitionId for "Facebook Marketing" — confirmed live
// against GET /dalmlabs/source_definitions (airbyte-api.ts). The only
// connector this workspace actually has a working provider for right now;
// everything else below is shown for catalog completeness but marked
// `disabled` until it has one too.
export const FACEBOOK_MARKETING_SOURCE_DEFINITION_ID = "e7778cfc-e97c-4458-9ecb-b4f2bba8946c";

// Real Airbyte destinationDefinitionId for "Postgres" — confirmed live
// against POST /destination_definitions/list and its own
// /destination_definition_specifications/get (host/port/database/schema/
// username required; ssl_mode and tunnel_method both default to their safe
// "off" variant — "disable" / "No Tunnel" — so the form is usable out of the
// box without the operator having to pick one first).
export const POSTGRES_DESTINATION_DEFINITION_ID = "25c5221d-dce2-4163-ade9-739ef790f503";

// Real Airbyte sourceDefinitionId for "RabbitMQ Bounded" — confirmed live
// against /source_definition_specifications/get. A custom in-house connector
// (Nachiket), not a stock Airbyte one — there are two RabbitMQ connectors
// registered on this workspace; only this one ("Bounded") is meant to be
// wired up here.
export const RABBITMQ_BOUNDED_SOURCE_DEFINITION_ID = "14516459-54ac-4a10-a137-129d662b9e60";

// Icons mapping
export const connectorIcons: Record<string, string> = {
  'Web SDK': '🌐',
  'Mobile SDK': '📱',
  'Postgres': '🐘',
  'MySQL': '🐬',
  'MongoDB': '🍃',
  'BigQuery': '🔍',
  'Snowflake': '❄️',
  'Redshift': '🔴',
  'S3': '📦',
  'Kafka': '⚡',
  'Kinesis': '🌊',
  'GA4': '📊',
  'Branch': '🌿',
  'Webhooks In': '🪝',
  'Elasticsearch': '🔎',
  'Salesforce': '☁️',
  'HubSpot': '🟠',
  'Braze': '🎯',
  'Iterable': '📧',
  'Klaviyo': '📩',
  'SendGrid': '✉️',
  'Shopify': '🛒'
};

export const sourceConnectors: Connector[] = [
  { id: 'facebook-marketing', name: 'Facebook Marketing', type: 'Source', status: 'Setup', icon: '📘', definitionId: FACEBOOK_MARKETING_SOURCE_DEFINITION_ID, disabled: false },
  { id: 'rabbitmq-bounded', name: 'RabbitMQ Bounded', type: 'Source', status: 'Setup', icon: '🐰', definitionId: RABBITMQ_BOUNDED_SOURCE_DEFINITION_ID, disabled: false },
  { id: '1', name: 'Web SDK', type: 'Source', status: 'Setup', icon: '🌐', disabled: true },
  { id: '2', name: 'Mobile SDK', type: 'Source', status: 'Setup', icon: '📱', disabled: true },
  { id: '3', name: 'Postgres', type: 'Source', status: 'Setup', icon: '🐘', disabled: true },
  { id: '4', name: 'MySQL', type: 'Source', status: 'Setup', icon: '🐬', disabled: true },
  { id: '5', name: 'MongoDB', type: 'Source', status: 'Setup', icon: '🍃', disabled: true },
  { id: '6', name: 'BigQuery', type: 'Source', status: 'Setup', icon: '🔍', disabled: true },
  { id: '7', name: 'Snowflake', type: 'Source', status: 'Setup', icon: '❄️', disabled: true },
  { id: '8', name: 'Redshift', type: 'Source', status: 'Setup', icon: '🔴', disabled: true },
  { id: '9', name: 'S3', type: 'Source', status: 'Setup', icon: '📦', disabled: true },
  { id: '10', name: 'Kafka', type: 'Source', status: 'Setup', icon: '⚡', disabled: true },
  { id: '11', name: 'Kinesis', type: 'Source', status: 'Setup', icon: '🌊', disabled: true },
  { id: '12', name: 'GA4', type: 'Source', status: 'Setup', icon: '📊', disabled: true },
  { id: '13', name: 'Branch', type: 'Source', status: 'Setup', icon: '🌿', disabled: true },
  { id: '14', name: 'Webhooks In', type: 'Source', status: 'Setup', icon: '🪝', disabled: true },
  { id: '28', name: 'Shopify', type: 'Source', status: 'Setup', icon: '🛒', disabled: true }
];

// Postgres is the only destination with a working provider on this
// workspace so far; every other entry stays `disabled` until it has one too
// (see sources.tsx's Facebook entry for the pattern once confirmed).
export const destinationConnectors: Connector[] = [
  { id: '15', name: 'Postgres', type: 'Destination', status: 'Setup', icon: '🐘', definitionId: POSTGRES_DESTINATION_DEFINITION_ID, disabled: false },
  { id: '16', name: 'BigQuery', type: 'Destination', status: 'Setup', icon: '🔍', disabled: true },
  { id: '17', name: 'Snowflake', type: 'Destination', status: 'Setup', icon: '❄️', disabled: true },
  { id: '18', name: 'Redshift', type: 'Destination', status: 'Setup', icon: '🔴', disabled: true },
  { id: '19', name: 'S3', type: 'Destination', status: 'Setup', icon: '📦', disabled: true },
  { id: '20', name: 'Kafka', type: 'Destination', status: 'Setup', icon: '⚡', disabled: true },
  { id: '21', name: 'Elasticsearch', type: 'Destination', status: 'Setup', icon: '🔎', disabled: true },
  { id: '22', name: 'Salesforce', type: 'Destination', status: 'Setup', icon: '☁️', disabled: true },
  { id: '23', name: 'HubSpot', type: 'Destination', status: 'Setup', icon: '🟠', disabled: true },
  { id: '24', name: 'Braze', type: 'Destination', status: 'Setup', icon: '🎯', disabled: true },
  { id: '25', name: 'Iterable', type: 'Destination', status: 'Setup', icon: '📧', disabled: true },
  { id: '26', name: 'Klaviyo', type: 'Destination', status: 'Setup', icon: '📩', disabled: true },
  { id: '27', name: 'SendGrid', type: 'Destination', status: 'Setup', icon: '✉️', disabled: true }
];

export const sourceOptions = ['Postgres', 'Shopify', 'MySQL', 'MongoDB', 'Snowflake', 'BigQuery', 'Redshift', 'S3', 'Kafka'];
export const destinationOptions = ['Postgres', 'BigQuery', 'Snowflake', 'Redshift', 'S3', 'Kafka', 'Elasticsearch'];

 export const ServiceIcon: React.FC<{
    src: string;
    alt: string;
    className?: string;
  }> = ({ src, alt, className = "" }) => (
    <div
      className={`w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center shadow-lg border border-gray-700 ${className}`}
    >
      <img src={src} alt={alt} className="w-8 h-8 object-contain" />
    </div>
  );

  const AddIcon: React.FC<{ className?: string }> = ({ className = "" }) => (
    <div
      className={`w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center shadow-lg border border-gray-700 cursor-pointer hover:bg-gray-700 transition-colors ${className}`}
    >
      <svg
        className="w-6 h-6 text-[#7B7B7B] font-semibold"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
      </svg>
    </div>
  );

  export const sourceIcons = [
    {
      id: 1,
      component: (
        <ServiceIcon
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg"
          alt="Facebook"
        />
      ),
      top: "15%",
    },
    {
      id: 2,
      component: (
        <ServiceIcon
          src="https://cdn.worldvectorlogo.com/logos/microsoft-teams-1.svg"
          alt="Microsoft Teams"
        />
      ),
      top: "35%",
    },
    {
      id: 3,
      component: (
        <ServiceIcon
          src="https://cdn.shopify.com/b/shopify-brochure2-assets/d9340911ca8c679b148dd4a205ad2ffa.svg"
          alt="Shopify"
        />
      ),
      top: "55%",
    },
    {
      id: 4,
      component: <AddIcon />,
      top: "75%",
    },
  ];

 export  const destinationIcons = [
    {
      id: 1,
      component: (
        <ServiceIcon
          src="https://companieslogo.com/img/orig/SNOW-35164165.png"
          alt="Snowflake"
        />
      ),
      top: "20%",
    },
    {
      id: 2,
      component: (
        <ServiceIcon
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Amazon-Redshift-Logo.svg/1024px-Amazon-Redshift-Logo.svg.png"
          alt="Amazon Redshift"
        />
      ),
      top: "40%",
    },
    {
      id: 3,
      component: (
        <ServiceIcon
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg"
          alt="SQL Server"
        />
      ),
      top: "60%",
    },
    {
      id: 4,
      component: <AddIcon />,
      top: "80%",
    },
  ];